/**
 * Questo file è responsabile della configurazione e creazione dello store Redux.
 * Lo store è il contenitore centrale e univoco per lo stato dell'intera applicazione.
 *
 * - Utilizza `configureStore` di Redux Toolkit, che semplifica la configurazione
 * includendo di default middleware utili come Redux Thunk (per la logica asincrona)
 * e strumenti di sviluppo (Redux DevTools).
 * - Combina tutti i "reducer" dei vari "slice" dell'applicazione in un unico
 * reducer radice. Ogni slice gestisce una porzione specifica dello stato.
 */

// Importa la funzione `configureStore` da Redux Toolkit.
import { configureStore } from '@reduxjs/toolkit';
// Importa il reducer dallo slice di autenticazione.
import authReducer from './authSlice';
// Importa il reducer dallo slice delle flashcard.
import flashcardReducer from './flashcardSlice';

// Configura e crea lo store.
export const store = configureStore({
  // L'oggetto 'reducer' mappa i nomi degli slice dello stato ai rispettivi reducer.
  // Quando un'azione viene dispatchata, Redux la passerà a tutti i reducer.
  reducer: {
    // La chiave 'auth' definisce che nello stato globale ci sarà una proprietà `state.auth`,
    // e questa porzione di stato sarà gestita da `authReducer`.
    auth: authReducer,
    // La chiave 'flashcards' definisce `state.flashcards`, gestita da `flashcardReducer`.
    flashcards: flashcardReducer
  }
});